import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const ChangePassword = React.lazy(() => import("@/pages/changePassword/ChangePassword"));
const ChangePasswords = [
  {
    path: "changePassword",
    element: (
      <SuspenseWrapper>
        <ChangePassword />
      </SuspenseWrapper>
    ),
  }
];

export default ChangePasswords;
